export function filterEmptyKey(data) {
  const obj = {}
  Object.keys(data).forEach(item => {
    if (data[item] !== null && data[item] !== '' && typeof (data[item]) !== 'undefined' && !obj[item]) {
      obj[item] = data[item]
    }
  })
  return obj
}

export function getMenu(menus = [], url) {
  // 菜单或当前路由无效时不授予按钮权限，避免权限初始化中断登录流程。
  if (!Array.isArray(menus) || typeof url !== 'string' || !url) return
  for (let i = 0; i < menus.length; i++) {
    if (!menus[i]) continue
    // 目录节点可以没有跳转地址；先校验地址，再按原有一级路径规则匹配权限。
    if (typeof menus[i].url === 'string' && menus[i].url && menus[i].url.split('/')[1] === url.split('/')[1]) {
      return menus[i]
    } else if (Array.isArray(menus[i].childNode) && menus[i].childNode.length) {
      const menu = getMenu(menus[i].childNode, url)
      if (menu) return menu
    }
  }
}

export function getMenuByCode(menus = [], code) {
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].menuCode === code) {
      return menus[i]
    } else if (menus[i].childNode && menus[i].childNode.length) {
      const menu = getMenuByCode(menus[i].childNode, code)
      if (menu) return menu
    }
  }
}

/**
 *var latlngs = [
 *    [40.41646957397461, 115.95511436462402],
 *    [40.411319732666016, 115.95399856567383],
 *    [40.40994644165039, 115.9647274017334],
 *    [40.416555404663086, 115.96558570861816]
 *  ]
 * 输入一组坐标计算中心点
 */
export function mapGetCenter(pointArray) {
  const sortedLongitudeArray = pointArray.map(item => item[1]).sort()
  const sortedLatitudeArray = pointArray.map(item => item[0]).sort()
  const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(4)
  const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(4)
  return [centerLongitude, centerLatitude]
}

/**
 * 将数字转成中文大写
 * @params num
 */
export function toChinesNum(num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (let i = 0; i < strArr.length; i++) {
      newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) noWan = '0' + noWan
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

export function getIndexPath(list = []) {
  if (list[0].childNode && list[0].childNode.length) {
    return getIndexPath(list[0].childNode)
  } else {
    return list[0].url
  }
}

/**
 * px转vw，页面为vw布局，
 * @return px单位数值
*/
export function px2vw(px) {
  return Math.ceil(px * (document.documentElement.clientWidth / 1920))
}

export function flatTreeList(list) {
  return list.reduce((prev, next) => {
    const {
      childNode,
      ...res
    } = next
    if (childNode && childNode.length) {
      return prev.concat(res, flatTreeList(childNode))
    } else {
      return prev.concat(res)
    }
  }, [])
}

/**
 * 深度克隆
 * @param {*} obj 需要深度克隆的对象
 * @returns {*} 克隆后的对象或者原值（不是对象）
 */
export function deepClone(obj, cache = new WeakMap()) {
  if (obj === null || typeof obj !== 'object') return obj
  if (cache.has(obj)) return cache.get(obj)
  let clone
  if (obj instanceof Date) {
    clone = new Date(obj.getTime())
  } else if (obj instanceof RegExp) {
    clone = new RegExp(obj)
  } else if (obj instanceof Map) {
    clone = new Map(Array.from(obj, ([key, value]) => [key, deepClone(value, cache)]))
  } else if (obj instanceof Set) {
    clone = new Set(Array.from(obj, value => deepClone(value, cache)))
  } else if (Array.isArray(obj)) {
    clone = obj.map(value => deepClone(value, cache))
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    clone = Object.create(Object.getPrototypeOf(obj))
    cache.set(obj, clone)
    for (const [key, value] of Object.entries(obj)) {
      clone[key] = deepClone(value, cache)
    }
  } else {
    clone = Object.assign({}, obj)
  }
  cache.set(obj, clone)
  return clone
}

/**
 * JS对象深度合并
 * @param {object} target 需要拷贝的对象
 * @param {object} source 拷贝的来源对象
 * @returns {object|boolean} 深度合并后的对象或者false（入参有不是对象）
 */
export function deepMerge(targetOrigin = {}, source = {}) {
  const target = deepClone(targetOrigin)
  if (typeof target !== 'object' || typeof source !== 'object') return false
  for (const prop in source) {
    if (!Object.prototype.hasOwnProperty.call(source, prop)) continue
    if (prop in target) {
      if (source[prop] == null) {
        target[prop] = source[prop]
      } else if (typeof target[prop] !== 'object') {
        target[prop] = source[prop]
      } else if (typeof source[prop] !== 'object') {
        target[prop] = source[prop]
      } else if (target[prop].concat && source[prop].concat) {
        target[prop] = target[prop].concat(source[prop])
      } else {
        target[prop] = deepMerge(target[prop], source[prop])
      }
    } else {
      target[prop] = source[prop]
    }
  }
  return target
}

/**
 * 将 Map 转换为对象数组
 * @param {Map} map - 要转换的 Map 对象
 * @param {Object} [options] - 自定义键名配置
 * @param {string} [options.valueKey='value'] - 对应 Map 键的属性名
 * @param {string} [options.labelKey='label'] - 对应 Map 值的属性名
 * @returns {Array} 转换后的对象数组
 */
export function mapToObjectArray(map, options = {}) {
  // 解构配置，使用默认值兜底
  const { valueKey = 'value', labelKey = 'label' } = options
  // 遍历 Map 键值对并转换
  return Array.from(map.entries()).map(([key, value]) => ({
    [valueKey]: key,
    [labelKey]: value
  }))
}

// 去重函数：参数1为原数组，参数2为ID字段名（默认是 id）
export function uniqueByID(arr, idKey = 'id') {
  const map = new Map()
  for (const item of arr) {
    // 关键：用 ID 作为键，存在则覆盖（保留最后一个），不存在则添加
    map.set(item[idKey], item)
    // 若想保留第一个出现的对象，改为：if (!map.has(item[idKey])) map.set(...)
  }
  return Array.from(map.values()) // 转为数组返回
}

/**
 * 复制文本到剪贴板
 * @param {string} text 需要复制的文本
 * @returns {Promise<boolean>} true复制成功，false复制失败
 */
export async function copyText(text) {
  // 非字符串、空内容直接返回失败
  if (text === null || text === undefined || String(text).trim() === '') {
    return false
  }
  const copyVal = String(text)

  // 优先现代剪贴板API
  try {
    await navigator.clipboard.writeText(copyVal)
    return true
  } catch (err) {
    console.warn('[copyText] clipboard api不可用，降级DOM复制', err)
  }

  // 降级：废弃execCommand兜底
  try {
    const input = document.createElement('input')
    input.value = copyVal
    input.style.position = 'fixed'
    input.style.left = '-9999px' // 移到可视区外，避免页面闪烁
    document.body.appendChild(input)
    input.select()
    const isOk = document.execCommand('copy')
    document.body.removeChild(input)
    return !!isOk
  } catch (domErr) {
    console.error('[copyText] DOM复制全部失败', domErr)
    return false
  }
}
